export default __webpack_public_path__ + "static/media/lock-solid.4fa4e4c1.svg";